import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const OPTIONS = [
  { key: "light", label: "Light", icon: Sun },
  { key: "dark", label: "Dark", icon: Moon },
  { key: "system", label: "Auto", icon: Monitor },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const base = "flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-full text-xs font-medium transition-all duration-200";
  const active = "bg-card text-foreground shadow-sm border border-border";
  const idle = "text-muted-foreground hover:text-foreground border border-transparent";
  return (
    <div data-testid="theme-toggle" className="flex items-center gap-1 p-1 rounded-full border border-border bg-secondary/40">
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          data-testid={`theme-${o.key}-btn`}
          onClick={() => setTheme(o.key)}
          className={`${base} ${theme === o.key ? active : idle}`}
        >
          <o.icon className="w-3.5 h-3.5" /> {o.label}
        </button>
      ))}
    </div>
  );
}
